import React, {useState, useEffect} from 'react';

import Alert from '../../alert/alert';
import {loadUser} from '../alert-template-services';

export default ({alert, toggleNotificationRead, closeMenu, push}) => {
    let {data: {hubName, hubId}, generatedBy} = alert.event;
    let [previousOwner, setPreviousOwner] = useState();
    useEffect(() => {
        loadUser(generatedBy, setPreviousOwner);
    }, []);

    let message, link;
    if (previousOwner) {
        message = <span><b>{previousOwner.name.fullName}</b> transferred ownership of the tag hub <b>{hubName}</b> to you</span>;
        link = '/gift-tags/hubs/' + hubId;
    }

    return (
        <Alert
            alert={alert}
            toggleNotificationRead={toggleNotificationRead}
            closeMenu={closeMenu}
            push={push}
            link={link}
        >
            {message || 'Loading Message...'}
        </Alert>
    );
}